import { useCallback, useState } from 'react';
import { BlockWrapper } from '@smartfire/js-block-engine';
import apiFetch from '@wordpress/api-fetch';
import { DealTile, Loading, isFloat } from '../components';
import Filter from './Filter';
import style from './block.module.scss';

const Block = ({ initialDeals, allTags, perPage, total, isUserConnected, isEmailVerified }) => {
    // Data states
    const [posts, setPosts] = useState(initialDeals);
    const [totalPosts, setTotalPosts] = useState(total);
    const [selectedTags, setSelectedTags] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    // Animation states
    const [isLoading, setIsLoading] = useState(false);

    const handleSelectTag = (tag) => {
        let temp;
        if (selectedTags.includes(tag.term_id)) {
            temp = selectedTags.filter((tagId) => tagId !== tag.term_id);
        } else {
            temp = selectedTags.concat(tag.term_id);
        }
        setSelectedTags(temp);
        loadMore(1, temp, false);
    };

    const loadMore = useCallback(
        (page, filter, shouldConcat) => {
            // Avoid several call of the same request
            if (shouldConcat && page === currentPage) return;
            // Avoid problem when totalPost is updated before posts (posts.length < totalPost)
            if (isFloat(page)) return;

            setCurrentPage(page);
            setIsLoading(true);

            let params = {
                page: page,
                per_page: perPage,
                deal_tags: filter.length > 0 ? filter.join() : -1,
            };

            apiFetch({
                path: '/myhand-deal/v1/get-deals?' + new URLSearchParams(params).toString(),
                parse: false,
            }).then((res) => {
                res.json().then((data) => {
                    if (shouldConcat) {
                        setPosts([...posts, ...data.posts]);
                    } else {
                        setPosts(data.posts);
                    }
                    setTotalPosts(data.total);
                });
                setIsLoading(false);
            });
        },
        [currentPage, perPage, posts],
    );

    return (
        <BlockWrapper.Div className={style.block}>
            <h1 className={style.title}>Bons plans</h1>

            {allTags.length > 0 && <Filter {...{ allTags, selectedTags, handleSelectTag }} />}

            {posts.length > 0 && (
                <div className={style.list}>
                    {posts.map((deal) => (
                        <DealTile key={deal.id} deal={deal} isEmailVerified={isEmailVerified} />
                    ))}
                </div>
            )}

            {posts.length < totalPosts && (
                <Loading
                    isLoading={isLoading}
                    onViewPortAppear={() => loadMore(posts.length / perPage + 1, selectedTags, true)}
                />
            )}
        </BlockWrapper.Div>
    );
};

export default Block;
